import React from 'react'

export function Loading() {
  return <p className='p-5'>Loading...</p>
}
